import React from 'react';

/*
 * Lockup de marca de Gastify, dibujado inline en vez de con el .svg de assets.
 * Sobre fondo oscuro el logo NO se puede invertir con un filtro: el isotipo es
 * un cuadro mint con la G calada en blanco, así que `brightness(0) invert(1)`
 * lo aplana en un cuadrado blanco. Acá el isotipo conserva su color y solo
 * cambia el color del wordmark.
 */
export default function GastifyBrand({
  textTone = 'dark',
  iconSize = 44,
  subtitle = 'Gestión clara para negocios en movimiento',
}) {
  const light = textTone === 'light';
  const wordmarkFill = light ? '#FFFFFF' : '#1F2421';
  const subtitleClass = light ? 'text-white/60' : 'text-[var(--gst-mint-700)]';
  const height = iconSize - 4;

  return (
    <div className="flex flex-col items-start gap-1">
      <svg
        viewBox="0 0 170 60"
        role="img"
        aria-label="Gastify"
        style={{ height, width: 'auto', display: 'block' }}
      >
        <defs>
          <linearGradient id="gst-brand-bg" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#10B981" />
            <stop offset="100%" stopColor="#059669" />
          </linearGradient>
        </defs>
        <rect x="0" y="4" width="52" height="52" rx="14" fill="url(#gst-brand-bg)" />
        <circle
          cx="26" cy="30" r="12.5" fill="none" stroke="#FFFFFF" strokeWidth="4.5"
          strokeLinecap="round" strokeDasharray="12.5 7.1" transform="rotate(45 26 30)"
        />
        <rect x="26" y="27.75" width="11.5" height="4.5" rx="2.25" fill="#FFFFFF" />
        <text
          x="64" y="39" fontFamily="'Manrope', system-ui, sans-serif"
          fontSize="26" fontWeight="800" letterSpacing="-0.5" fill={wordmarkFill}
        >
          Gastify
        </text>
      </svg>
      {subtitle && (
        <div className={`mt-1 text-[0.62rem] font-bold uppercase tracking-[0.28em] ${subtitleClass}`}>
          {subtitle}
        </div>
      )}
    </div>
  );
}
